<template>
    <b-row>
        <b-col>
            <b-row align-h="center" align="center">

                <!--CAMBIAR CONTRASEÑA-->
                <!--
                <b-col cols="6" lg="3" class="card-option mb-4 ml-4 mr-4 " style="cursor: pointer;">

                    <div>
                        <b-icon icon="key" font-scale="6" class="mb-1 mt-4" @click="cambiarPass"></b-icon>
                        <h5 class="mb-5">Cambiar contraseña</h5>
                    </div>

                    <b-modal v-model="modalShow9" hide-footer header-text-variant="light" header-bg-variant="dark"
                        title="Cambiar contraseña">
                        <h5><strong>Ingrese su nueva contraseña</strong></h5>
                        <b-form-input class="text-center" type="number" number v-model="contraseña"
                            placeholder="Ingrese 3 caracteres númericos" :state="validacionCambioPass"></b-form-input>
                        <p></p>
                        <b-form-input class="text-center" type="number" number v-model="contraseñaConfirma"
                            placeholder="Confirme la contraseña" :state="validacionCambioPassConfirma"></b-form-input>
                        <p></p>
                        <b-row v-if="contraseña != '' & contraseñaConfirma != ''">
                            
                            <b-col>
                                <b-row v-if="contraseña != contraseñaConfirma">
                                    <b-col>
                                        <b-alert class="text-center" show variant="danger">LA CONTRASEÑA NO COINCIDE</b-alert>
                                    </b-col>
                                </b-row>
                                <b-row v-if="banderaLongitud == 1">
                                    <b-col>
                                        <b-alert class="text-center" show variant="danger">LA CONTRASEÑA DEBE TENER 3 CARACTERES</b-alert>
                                    </b-col>
                                </b-row>
                                <b-row v-if="contraseña == contraseñaConfirma" align-h="center" align="center"><b-col>
                                        <b-button variant="success" pill @click="enviarPass">Cambiar</b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        
                    </b-modal>

                </b-col>
                -->
            </b-row>
        </b-col>
    </b-row>
</template>




<script>
import axios from 'axios'




export default {


    computed: {

        validacionCambioPass() {
            return this.contraseña == '' ? false : true
        },
        validacionCambioPassConfirma() {
            return this.contraseñaConfirma == '' ? false : true
        },

        token: {
            get: function () {
                return this.$store.state.user.token;
            },
            set: function (newIsWorking) {
                this.$store.commit("updateToken", newIsWorking);
            }
        }

    },

    data() {
        return {
            //variables Generacion Vale
            cliente: "",
            //url: "http://192.168.0.100:8080/",
            //url: "https://optimal-central-pug.ngrok-free.app/",
            //url: "https://tphavawsqa.a.pinggy.link/",
            //url: "http://192.168.0.101:8080/",
            url: "https://recaudacion.gobrecservices.com/",

            contraseña: '',
            contraseñaConfirma: '',
            modalShow9: false,
            contraseñaBase64: '',
            banderaLongitud: 0,
            valorError: ''

        }
    },


    created: function () {

        const queryString = window.location.href;

        const url = new URL(queryString);

        const cliente = url.pathname.split('/')[1];

        this.cliente = cliente

        axios({
            method: 'post',
            url: this.url + 'catalogosum',
            params: { "codeClient": this.cliente },
            data: null,
            headers: {
                'Authorization': this.token,

            }
        })
            .then((res) => {
                this.departamentos = res.data.departamentos
                this.unidades = res.data.unidades
                this.operadores = res.data.operadores
                this.proveedores = res.data.proveedores

                this.unidadesTabla = res.data.unidades

            }).catch(err => {

                if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

                    alert('Servicio no disponible, intente de nuevo más tarde');

                }

                else if (err.response.status == 500) {

                    alert('Error en la red, verifique su conexión a internet 7');
                }

                else {

                    alert(err);

                }
            });

    },


    methods: {


        cambiarPass() {


            this.modalShow9 = true;

        },


        enviarPass() {

            //alert(this.contraseñaConfirma)
            //alert(this.contraseñaConfirma.toString().length)

            if (this.contraseñaConfirma.toString().length != 3) {
                this.banderaLongitud = 1
            }
            else {
                this.banderaLongitud = 0

                this.enviarPass2();
            }

        },

        enviarPass2() {

            this.contraseñaBase64 = btoa(this.contraseña);


            axios({
                method: 'post',
                url: this.url + 'passwordsuministro',

                data: {
                    'password': this.contraseñaBase64,

                },
                headers: {
                    'Authorization': this.token,

                }
            })
                .then((res) => {

                    this.modalShow9 = false;
                    this.contraseña = ''
                    this.contraseñaConfirma = ''

                    alert(res.data)

                }).catch(err => {

                    //this.valorError = JSON.stringify(err);

                    //alert(this.valorError.message)
                    //alert(err.message)


                    if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

                        alert('Servicio no disponible, intente de nuevo más tarde');

                        //this.contraseña = ''
                        //this.contraseñaConfirma = ''

                    }

                    else if (err.response.status == 500) {

                        alert('Error en la red, verifique su conexión a internet 6');
                    }

                    else {
                        if (err.config.headers.Authorization != null) {

                            const queryString = window.location.href;
                            const url = new URL(queryString);
                            const cliente = url.pathname.split('/')[1];
                            window.location.href = '/' + cliente + '/login';
                        }

                        //alert(err + " Servicio no disponible, intente de nuevo más tarde");


                    }

                });
        }



        /*
            
    descargaTablaVales() {

        var byteString = atob(this.archivoValesBase64);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);

        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        FileSaver.saveAs(new Blob([ab],{type:"application/octet-stream"}), 'ejemplo.xlsx');


        },
        */

    }
}

</script>



<style>
/* BASIC */

html {
    background-color: #ffffff;
}

body {
    font-family: "Poppins", sans-serif;
    height: 100vh;
}

a {
    color: #92badd;
    display: inline-block;
    text-decoration: none;
    font-weight: 400;
}

h2 {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    display: inline-block;
    margin: 40px 8px 10px 8px;
    color: #cccccc;
}



/* STRUCTURE */

.wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    min-height: 100%;
    padding: 20px;
}

#formContent {
    -webkit-border-radius: 10px 10px 10px 10px;
    border-radius: 10px 10px 10px 10px;
    background: #fff;
    padding: 30px;
    width: 90%;
    max-width: 450px;
    position: relative;
    padding: 0px;
    -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
    box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
    text-align: center;
}

#formFooter {
    background-color: #f6f6f6;
    border-top: 1px solid #dce8f1;
    padding: 25px;
    text-align: center;
    -webkit-border-radius: 0 0 10px 10px;
    border-radius: 0 0 10px 10px;
}



/* TABS */

h2.inactive {
    color: #cccccc;
}

h2.active {
    color: #0d0d0d;
    border-bottom: 2px solid #ffffff;
}



/* FORM TYPOGRAPHY*/

input[type=button],
input[type=submit],
input[type=reset] {
    background-color: #56baed;
    border: none;
    color: white;
    padding: 15px 80px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    text-transform: uppercase;
    font-size: 13px;
    -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
    box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
    -webkit-border-radius: 5px 5px 5px 5px;
    border-radius: 5px 5px 5px 5px;
    margin: 5px 20px 40px 20px;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

input[type=button]:hover,
input[type=submit]:hover,
input[type=reset]:hover {
    background-color: #39ace7;
}

input[type=button]:active,
input[type=submit]:active,
input[type=reset]:active {
    -moz-transform: scale(0.95);
    -webkit-transform: scale(0.95);
    -o-transform: scale(0.95);
    -ms-transform: scale(0.95);
    transform: scale(0.95);
}

input[type=text] {
    background-color: #f6f6f6;
    border: none;
    color: #0d0d0d;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 5px;
    width: 85%;
    border: 2px solid #f6f6f6;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
    -webkit-border-radius: 5px 5px 5px 5px;
    border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus {
    background-color: #fff;
    border-bottom: 2px solid #5fbae9;
}

input[type=text]:placeholder {
    color: #cccccc;
}



/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
    -webkit-animation-name: fadeInDown;
    animation-name: fadeInDown;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(0, -100%, 0);
        transform: translate3d(0, -100%, 0);
    }

    100% {
        opacity: 1;
        -webkit-transform: none;
        transform: none;
    }
}

@keyframes fadeInDown {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(0, -100%, 0);
        transform: translate3d(0, -100%, 0);
    }

    100% {
        opacity: 1;
        -webkit-transform: none;
        transform: none;
    }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@-moz-keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.card-option {
    box-shadow: 0px 5px 35px 5px #cccaca;
    border-radius: 15px;
    border-bottom: solid 4px rgb(68, 63, 173);
    background-color: white;
}

.fadeIn {
    opacity: 0;
    -webkit-animation: fadeIn ease-in 1;
    -moz-animation: fadeIn ease-in 1;
    animation: fadeIn ease-in 1;

    -webkit-animation-fill-mode: forwards;
    -moz-animation-fill-mode: forwards;
    animation-fill-mode: forwards;

    -webkit-animation-duration: 1s;
    -moz-animation-duration: 1s;
    animation-duration: 1s;
}

.fadeIn.first {
    -webkit-animation-delay: 0.4s;
    -moz-animation-delay: 0.4s;
    animation-delay: 0.4s;
}

.fadeIn.second {
    -webkit-animation-delay: 0.6s;
    -moz-animation-delay: 0.6s;
    animation-delay: 0.6s;
}

.fadeIn.third {
    -webkit-animation-delay: 0.8s;
    -moz-animation-delay: 0.8s;
    animation-delay: 0.8s;
}

.fadeIn.fourth {
    -webkit-animation-delay: 1s;
    -moz-animation-delay: 1s;
    animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
    display: block;
    left: 0;
    bottom: -10px;
    width: 0;
    height: 2px;
    background-color: #56baed;
    content: "";
    transition: width 0.2s;
}

.underlineHover:hover {
    color: #0d0d0d;
}

.underlineHover:hover:after {
    width: 100%;
}



/* OTHERS */

*:focus {
    outline: none;
}

#icon {
    width: 60%;
}
</style>